module.exports = __webpack_public_path__ + "img/Cable.ecb26f4a.svg";